import { getPageId } from '../biz-meta'
import { log } from '../logs'

/**
 * 获取调试配置的函数
 * @returns 调试配置 或 null
 */
function getDebugConfig(): IDebugConfig | null {
  /**
   * 获取调试配置
   */
  let debugConfig = window.fl?.debugConfig

  /**
   * 验证调试配置是否存在
   */
  if (!debugConfig) {
    return null
  }

  /**
   * 如果在meta中找到了pageId并且同时找到了debugConfig，则记录为警告并忽略 debugConfig
   */
  if (getPageId() && debugConfig) {
    log.warn('在meta中找到了pageId并且同时找到了debugConfig，将忽略debugConfig')
    return null
  }

  /**
   * 如果systemEnv不存在，则设置为prod
   */
  if (!debugConfig.systemEnv) {
    debugConfig.systemEnv = 'prod'
  }

  /**
   * 验证环境配置是否有效
   */
  if (debugConfig.systemEnv && !['qa', 'pp', 'prod'].includes(debugConfig.systemEnv)) {
    throw new Error(`systemEnv 系统环境配置无效: ${debugConfig.systemEnv}，可选值为: "qa" | "pp" | "prod"`)
  }

  /**
   * 如果gp不存在，则设置为0
   */
  if (!debugConfig.gp) {
    debugConfig.gp = 0
  }

  /**
   * 验证gp配置是否有效
   */
  if (debugConfig.gp && ![0, 1].includes(debugConfig.gp)) {
    throw new Error(`gp配置无效: ${debugConfig.gp}，可选值为: 0 | 1`)
  }

  /**
   * 验证调试配置是否是一个数组
   */
  if (!Array.isArray(debugConfig.pages)) {
    throw new Error('调试配置不是一个数组')
  }

  /**
   * 验证每个调试配置项
   * @param config - 调试配置项
   * @returns {boolean} 是否有效
   */
  const validatePage = (config: any): string => {
    let errorMessage = ''
    if (!config.pageName || typeof config.pageName !== 'string') {
      errorMessage = '页面名称必须是一个字符串，例如: "首页"'
    } else if (!config.pageId || typeof config.pageId !== 'string') {
      errorMessage = '页面ID必须是一个字符串，例如: "sfifr0qlpts2"'
    } else if (typeof config.match !== 'function') {
      errorMessage = 'match必须是一个函数，例如: () => location.hash === "#home"'
    } else if (!config.lang || typeof config.lang !== 'string') {
      errorMessage = '语言必须是一个字符串，例如: "en"'
    }
    if (errorMessage) {
      return errorMessage
    }
    return ''
  }

  /**
   * 验证每个调试配置项
   */
  let errors: string[] = []
  debugConfig.pages.forEach((config, index) => {
    const errorMessage = validatePage(config)
    if (errorMessage) {
      errors.push(`调试配置项 ${index} 不是有效的配置: ${errorMessage}`)
    }
  })

  /**
   * 如果存在错误，则抛出错误
   */
  if (errors.length > 0) {
    throw new Error(errors.join(', '))
  }

  /**
   * 返回调试配置
   */
  return debugConfig
}

/**
 * 获取调试配置
 */
export const debugConfig = getDebugConfig()

/**
 * 获取当前调试配置
 * @returns 当前调试配置 或 null
 */
export const getCurrentDebugConfigMatchPage = (): IDebugConfigPage | null => {
  if (!debugConfig) {
    return null
  }
  const currentDebugConfig = debugConfig.pages.find((config) => config.match())
  return currentDebugConfig || null
}
